import { authStore, authMethods } from '@/store/auth.store';

// Mixin that provides authentication state and methods to all components
export const authMixin = {
  computed: {
    $auth() {
      return {
        user: authStore.user,
        isAuthenticated: authStore.isAuthenticated,
        ...authMethods
      };
    }
  }
};
